module.exports = __webpack_public_path__ + "static/media/013.63e34f06.jpg";